// import actions from "./actions";
//
// const {FETCH_FINAL} = actions;
// const initState = {
//     final: [],
// };
//
// const FinalReducer = (state = initState, action) => {
//     const {type, data} = action;
//     switch (type) {
//         case FETCH_FINAL:
//             return {
//                 ...state,
//                 final: data
//             }
//         default:
//             return state;
//     }
// }
//
// export default FinalReducer;


import actions from "./actions";

const { FETCH_FINAL, UPDATE_SINGLE_STUDENT_FINAL } = actions;
const initState = {
    final: [],
};

const FinalReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_FINAL:
            return {
                ...state,
                final: data
            };
        case UPDATE_SINGLE_STUDENT_FINAL:
            return {
                ...state,
                // Maps through existing students and swaps only the updated record
                final: state.final.map((student) =>
                    student.student._id === data.student._id ? data : student
                )
            };
        default:
            return state;
    }
}

export default FinalReducer;
